import { render } from "./provided.vue?vue&type=template&id=4b6e331b"
import script from "./provided.vue?vue&type=script&lang=js"
export * from "./provided.vue?vue&type=script&lang=js"

import "./provided.vue?vue&type=style&index=0&id=4b6e331b&lang=scss"

import exportComponent from "/builds/front-end/site-cms/deploy_site_cdn/site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__loftyFile', 'src/modules/md-detail-info/provided.vue'],['render',render],['__file',"provided.vue"]])

export default __exports__